// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"438":"attendance","7920":"library","8778":"people"}[chunkId] || chunkId) + "." + {"438":"94eeeac6","5503":"da80946c","7920":"f9186aca","8345":"5d2404c7","8778":"b7db6b58"}[chunkId] + ".chunk.css";
};